import React from 'react';
import { motion } from 'framer-motion';
export function Testimonials() {
  return <section className="bg-white overflow-hidden" data-id="element-224">
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-225">
        <img src="https://cdn.magicpatterns.com/uploads/6EUbVwhHsDAhhpMFbGuRW7/ChatGPT_Image_30_abr_2026,_10_18_23_a.m..png" alt="Testimonios — Resultados reales de personas reales" className="w-full h-auto block" style={{
        imageRendering: 'auto'
      }} data-id="element-226" />
      </motion.div>
    </section>;
}